import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default ({
  namespaced: true,
  state: {
    trends: [],
    trend: {}
  },
  mutations: {
    TRENDS(state, trends) {
      state.trends = trends
    },
    TREND(state, trend) {
      state.trend = trend
    }
  },
  actions: {
    loadTrends(context, reviewId) {
      Vue.axios.get('/api/trend/list', {
        params: {
          reviewId: reviewId
        }
      }).then((res) => {
        context.commit('TRENDS', JSON.parse(res.data))
      })
    }
  },
  getters: {
    getTrend(state) {
      return state.trend
    },
    getTrends(state) {
      return state.trends
    }

  }
})